<template>
  <vs-row vs-w="12">
  
      <GlobalFilters 
        :categories="categories"
        :subCategories="subCategories"
        :selectedCategory="selectedCategory"
        :selectedSubCategory="selectedSubCategory"
        @updateSelectedCategory="selectedCategory = $event"
        @updateSelectedSubCategory="selectedSubCategory = $event"
        :selected="selected"
        @updateFilters="selected = $event"
        :page="'percent-of-treatment'"
        :isOvertime="byOverTime"
        :urlType="urlType"
        :isAllClinics="isAllClinics"
      />

      <!-- Chart -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 md: gap-y-0 items-center w-full my-4">
        <div v-if="urlType === 'Supplier' && !byNurse && !byClinic" class="flex items-center justify-between space-x-4 bg-gray-100 py-3 px-4 rounded-lg w-full  md:col-start-1">
            <label class="optionslabel"> All Clinics 
              <span class="block text-xs text-gray-600">( Counts all clinics within FreshClinics )</span>
            </label>
            <vs-switch
              :value="isAllClinics"
              @input="updateIsAllClinics"
            />
        </div>
        <p v-if="allTotalCount" class="optionslabel w-full md:col-start-2 text-center md:text-right">Total count of treatments: {{ Number.parseFloat(allTotalCount).toFixed(0) }}</p>
      </div>

      <BarChart 
        :chartData="chartData"
        :chartOptions="chartOptions"
      />

    </vs-row>
</template>

<script>
import BarChart from '../charts/BarChart.vue';
import GlobalFilters from '../common/GlobalFilters';
import {
  filterCategories,
} from '../common/GlobalFilters/filterConstant.js';
import { mapActions, mapMutations, mapState } from 'vuex';
import _ from 'lodash';
import helper from '../../../superAdmin/insights/helper';

export default {
  components: {
    BarChart,
    GlobalFilters,
  },
  props: {
    tabs: Array,
    byNurse: Boolean,
    byClinic: Boolean,
    byOverTime: Boolean,
    isStacked: {
      type: Boolean,
      default: false,
    },
    isAllClinics: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('analytics', ['chartData','table', 'FILTERS_SELECTED']),
    allTotalCount(){      
      let count = 0;
      if(this.byNurse || this.byClinic) {
        const chartDataSets = this.chartData.datasets ? this.chartData.datasets : null;
        if(chartDataSets) {
          chartDataSets.forEach(dataSet => {
            dataSet.totalCount.forEach(val => {
                count += val;
            });
          });
        }
      } else {
        const chartDataSets = this.chartData.datasets ? this.chartData.datasets[0] : null;
        if(chartDataSets && chartDataSets.totalCount) {
          chartDataSets.totalCount.forEach(val => {
              count += val;
          });
        }
      }

      return count;
    },
  },
  data() {
    return {
      categories: [
        filterCategories.ORGANIZATIONS,
        filterCategories.CLINICS,
        filterCategories.NURSE,
        filterCategories.PATIENTS,
        filterCategories.TREATMENTS,
      ],
      selectedCategory: {},
      subCategories: [],
      selectedSubCategory: {},
      selected: {},
      static: {
        temp_brand: [],
      },
      // Chart data
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            display: this.byNurse || this.byClinic ? true : false,
            position: 'top',
            labels: {
              boxWidth: 12,
            },
          },
          title: {
            display: true,
            text: '',
          },
          tooltip: {
            callbacks: {
              footer: function(context) {
                const contextItem = context[0];
                const totalCount = contextItem.dataset.totalCount; 
                let totalCountLabel = '';

                if(totalCount){
                  if(totalCount.length){
                    totalCountLabel = 'Count: ' + totalCount[contextItem.dataIndex];
                  } else {
                    totalCountLabel = 'Count: ' + totalCount;
                  }
                }
                return totalCountLabel;
              },
            },
          },
        },
        scales: {
          y: {
            title: {
              display: true,
              text: this.byOverTime ? '% Brand Share' : 'Share of Treatments (%)',
            },
            min: 0,
            max: this.byNurse || this.byClinic ? 100 : null,
            stacked: this.isStacked,
          },
          x: {
            title: {
              display: true,
              text: this.byNurse ? 'Nurse' : this.byClinic ? 'Clinic' : this.byOverTime ? 'Month - Year' : 'Brand',
            },
            grid : {
              display : false,
            },
            stacked: this.isStacked,
            ticks: {
              font: {
                size: 10,
              },
              maxRotation: this.byNurse || this.byClinic ? 90 : 0,
              minRotation: this.byNurse || this.byClinic ? 90 : 0,
            },
          },
        },
      },
      urlType: '',
      orgId: '',
    };
  },
  methods:{
    ...mapActions('analytics', ['fetchBrandsAverageByArea']),
    ...mapMutations('analytics', ['MUTATE_CHART_DATA', 'MUTATE_TABLE_DATA', 'MUTATE_TABLE_HEADERS']),
    fetchBrandsAverageByAreaChartData() {
      
      let payload = helper.generateAnalyticsAPIParameters(this.selected);
      payload.is_nurse = this.byNurse;

      if(this.selected.brand && this.selected.brand.length && this.static.temp_brand[0] === 0){
        payload.brand = this.selected.brand;
        payload.is_all_clinics = this.isAllClinics;
      } else {
        payload.brand = this.static.temp_brand;
        payload.is_all_clinics = this.isAllClinics;
      }

      if (['OrgOwner', 'SuperAdmin'].includes(this.urlType)){
        payload.brand = this.selected.brand;
      }
    
      if(this.byClinic){
        payload = {
          ...payload,
          is_clinic: this.byClinic,
        };
      }
      if(!['SuperAdmin', 'Supplier'].includes(this.urlType)){
        payload = {
          ...payload,
          org: [this.orgId],
        };
      }

      if (this.urlType === 'Supplier') {
        payload = {
          ...payload,
          is_supplier: true,
          supplier_brand: this.static.temp_brand,
          brand: this.selected.brand,
        };
      }
      
      this.fetchBrandsAverageByArea(payload).then((res) => {
        const headers= res.data.chartData.datasets.map((data)=>data.label);
        const tableHeaders = [this.byNurse?'Nurse': this.byClinic? 'Clinic' : this.byOverTime? 'Month-Year' : 'Brand', 
        ..._.pullAll(this.byNurse || this.byClinic? headers : [null],[null])];
        if(!this.byNurse && !this.byClinic && !this.byOverTime){
          tableHeaders.push('% of treatment');
        } else if(this.byOverTime){
          tableHeaders.push('% Brand Share');
        }
        this.MUTATE_TABLE_HEADERS(tableHeaders);
        this.MUTATE_CHART_DATA(res.data.chartData);

        const { labels, datasets } = res.data.chartData;
        const tableData = labels.map((label, index) => {
          return {
            brand: label,
            values:this.getvalues(index,datasets),
            percent_treatment: datasets[0].data[index] + ' %',
          };
        });
        this.MUTATE_TABLE_DATA(tableData);
      });
    },
    getvalues(index,datasets){
      const data = datasets.map( brand => {
          return brand.data[index] + ' %';
        } );
      return data;
    },
    updateIsAllClinics(val){
      this.$emit('updateIsAllClinics', val);
    },
  },
  created() {
    this.selected = _.cloneDeep(this.FILTERS_SELECTED);
    this.MUTATE_TABLE_DATA([]);
    this.MUTATE_CHART_DATA({});
    let userType = JSON.parse(
      localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)
    );
    if(userType && userType.userType === 'superAdmin'){
      this.urlType = 'SuperAdmin';
    }else if(userType && userType.organizations[0].role.toUpperCase() === 
    'supplier'.toUpperCase()){
      this.urlType = 'Supplier';
    }else{
      this.urlType = 'OrgOwner';
    }
    if(localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`)){
      this.orgId = localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`);
    }
    if(userType && userType.brands.length){
      this.static.temp_brand = userType.brands;
    } else if(this.urlType == 'Supplier' || this.urlType == 'OrgOwner'){
      this.selected.brand = [];
      this.static.temp_brand[0] = 0;
    }
  },
  watch: {
    selected: {
      handler() {
        this.fetchBrandsAverageByAreaChartData();
      },
      deep: true,
    },
    isAllClinics: {
      handler(value) {
        this.fetchBrandsAverageByAreaChartData();
        if(value) {
          // Reset all selected data from CLINICS and NURSE subcategories
          filterCategories.CLINICS.subCategory.forEach((subCategory) => {
            if(this.selectedSubCategory.filterKey === subCategory.filterKey){
              this.selectedSubCategory = {};
            }
            this.selected[subCategory.filterKey] = [];
          });
          filterCategories.NURSE.subCategory.forEach((subCategory) => {
            if(this.selectedSubCategory.filterKey === subCategory.filterKey){
              this.selectedSubCategory = {};
            }
            this.selected[subCategory.filterKey] = [];
          });
        }
      },
    },
  },
};
</script>

<style>
  .optionslabel {
    font-size: .85rem;
  }
</style>